import React, { Component } from 'react';

import './Modal.css';
import Illupays from '../Icons/Illupays.svg';
import Close from '../Icons/Close.svg';
import Loader from '../Icons/Loader';

class ModalBack extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
	    	amountSelected: 0,
	    	walletAmount: this.props.currentUser.wallet,
	    	wrongAmount: false
	    };
	    this.hideModal = this.hideModal.bind(this);
	    this.handleChange = this.handleChange.bind(this);
	    this.handleSubmit = this.handleSubmit.bind(this);
	}

	hideModal() {
		this.props.actions.hideModal();
	}

	handleChange(event) {
	    this.setState({
	    	amountSelected: event.target.value,
	    	walletAmount: Math.round((this.props.currentUser.wallet - event.target.value) * 100) / 100
	    });
	}

	handleSubmit(event) {
		event.preventDefault();
		if(this.state.amountSelected >= 1 && this.state.amountSelected <= this.props.currentUser.wallet){
			this.setState({wrongAmount: false});
			this.props.actions.backingAction(this.props.dataID,this.state.amountSelected,this.props.title);
			this.props.backFormValid();
			this.props.messageInfo();
		}else{
			this.setState({wrongAmount: true});
		}
	}

  	render() {
	    return (
			<div>
				<div className="modalBackground" onClick={() => this.hideModal()} ></div>
				<div className="modalContainer back">
					<div className="modalBloc">
						<div className="close" onClick={() => this.hideModal()} ><img src={Close} alt="Close" /></div>
						<div className="content">
							<div className="userBloc">
								<div className="userAvatar"><img src={this.props.currentUser.avatar} alt="avatar" /></div>
								<div className="userAmount">€{this.state.walletAmount}</div>
							</div>
							<div className="illustration"><img src={Illupays} alt="Sheep and money" /></div>
							<div className="title">How much money do you want to give to this project?</div>
							<form onSubmit={this.handleSubmit}>
								<div className="input"><input type="number" step=".01" min="1" max="150" onChange={this.handleChange} placeholder="Don't give more than you have :)" /></div>
								<div className="actions">
									<div className="button is-abort" onClick={() => this.hideModal()} >Cancel</div>
									<button className="button is-primary" disabled={this.props.backingIsLoading}>{this.props.backingIsLoading ? <Loader color="#fff" /> : 'Make it pigger'}</button>
								</div>
								{this.state.wrongAmount &&
									<div className="errorMessage">You don't have enough money left!</div>
								}
							</form>
						</div>
					</div>
				</div>
			</div>
	    );
  	}
}

export default ModalBack;



// WEBPACK FOOTER //
// ./src/components/Modal/ModalBack.js